import { t } from "i18next"

export default function secondsToHumanReadable(seconds: number) {
  if (seconds <= 3600) {
    return `${Math.floor(seconds / 60)}${t('charger_m')}`
  }

  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds - (hours * 3600)) / 60)
  return `${hours}${t('charger_h')} ${minutes}${t('charger_m')}`
}